interface MoveInAgreement {
  housingId: string;
  moveInDate: string;
  showMoveInNotice: boolean;
}

export const MoveInAgreements: MoveInAgreement[] = [];
